export const JOB_ACTIVITY_IMAGE_SIZE = '64px';
